import { Dictionary } from "flow/api/types";
import { generateCleanSearchParams } from "./generateCleanSearchParams";
import config from "flow/config";

function getViewContext(fragment: string) {
    const dictionary: Dictionary = {};
    const parts = fragment.split("/");

    parts.splice(0, 2);

    for (let i = 0; i < parts.length - 1; i += 2) {
        dictionary[parts[i]] = parts[i + 1];
    }

    return dictionary;
}

function getViewContextWithoutSelectedContainer(fragment: string) {
    const { _containerId, ...viewContext } = getViewContext(fragment);
    return viewContext;
}

function getSelectedContainerId(fragment: string) {
    const { _containerId } = getViewContext(fragment);
    return _containerId;
}

function makeViewContextStringForWorkingContext(
    workingContextId: string,
    viewContext: Dictionary,
    selectedContainerId: string
) {
    let paramString = "#/" + workingContextId;

    if (selectedContainerId) {
        paramString += `/${config.selectedContainerPropertyName}/${selectedContainerId}`;
    }

    for (const property in viewContext) {
        paramString += "/" + property + "/" + viewContext[property];
    }

    return paramString;
}

function makeViewContextStringForExternalComponent(viewContext: Dictionary, cacheBuster: string) {
    const mergedObj = Object.assign({ cacheBuster: cacheBuster }, viewContext);
    return generateCleanSearchParams(mergedObj);
}

function getContextId(fragment: string) {
    const parts = fragment.split("/");
    return parts.length > 1 ? parts[1] : fragment;
}

function tryGetContextId(fragment: string) {
    const parts = fragment.split("/");
    return parts.length > 1 ? parts[1] : "";
}

function getAppWithParameterViewModelId(fragment: string) {
    fragment = fragment.replace("/App/", "");
    const viewModelId = fragment == "/App" ? "" : fragment;
    return viewModelId;
}

function getViewModelId(fragment: string) {
    if (fragment === "/App") {
        return "";
    }
    fragment = fragment.replace("/App/", "/");
    const fragments = fragment.split("/");
    return fragments[1];
}

function makeViewContextStringForDefaultWorkingContext(viewModelId: string, viewContext: Dictionary) {
    let paramString = "#/App/" + viewModelId;

    for (const property in viewContext) {
        paramString += "/" + property + "/" + viewContext[property];
    }

    return paramString;
}

export default {
    getViewContext,
    getViewContextWithoutSelectedContainer,
    getSelectedContainerId,
    makeViewContextStringForWorkingContext,
    makeViewContextStringForExternalComponent,
    makeViewContextStringForDefaultWorkingContext,
    getContextId,
    tryGetContextId,
    getViewModelId,
    getAppWithParameterViewModelId
};
